// ----------------------------------------------------------------------------
// Nombre del Programa : PaginaError
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para mostrar una vista de error al usuario en caso de que no este bien configurada
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './PaginaError.scss';
import { Row, Col } from 'react-bootstrap';

export const PaginaError = () => {
    return (
        <>
            <div className="m-5">
                <Row className="mt-3">
                    <Col>
                        <Row className="titulo">
                            <Col className="h4"> Error al cargar la pagina</Col>
                        </Row>
                        <Row>
                            <Col className="texto-contenido h5 mt-3">
                                {' '}
                                Verifique que todos las configuraciones esten bien realizadas,
                                Valide que app.txt exista en la ruta especificada y vuelva a
                                recargar la pagina.
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    );
};
